import { VeiculoModel } from "@/models/veiculo/VeiculoModel";
import { VeiculoModel as VeiculoModelAssistencia } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import { consultaVeiculoApi } from "@/api/ConsultaVeiculoApi";
import { TIPOS_VEICULO } from "@/models/veiculo/TipoVeiculoModel";
import { TIPOS_VEICULO as TIPOS_VEICULO_ASSISTENCIA} from "@/models/cadastros/assistencia/veiculo/TipoVeiculoModel";
import { DadosVeiculoInfoCarDTO } from '@/api/assistencia24h/DadosVeiculoInfoCarDTO';

export class ConsultaVeiculoService {
  public async obterVeiculos(placa: string): Promise<VeiculoModel[]> {
    const veiculoDTO = await consultaVeiculoApi.obterInformacoesVeiculo(placa);
    return this.parseVeiculo(veiculoDTO);
  }

  public async obterVeiculosChassi(chassi: string): Promise<VeiculoModel[]> {
    const veiculoDTO = await consultaVeiculoApi.obterInformacoesVeiculoChassi(chassi);
    return this.parseVeiculo(veiculoDTO);
  }

  private parseVeiculo(veiculoDTO: DadosVeiculoInfoCarDTO) {
    return [
      {
        placa: veiculoDTO.placa,
        marca: veiculoDTO.marca,
        modelo: veiculoDTO.modelo,
        anoFabricacao: veiculoDTO.anoFabricacao,
        anoModelo: veiculoDTO.anoModelo,
        cor: veiculoDTO.cor,
        chassi: veiculoDTO.chassi,
        tipoVeiculo: TIPOS_VEICULO.find((tipo) => {
          return (tipo.name == veiculoDTO.tipoVeiculo);
        }),
      },
    ];
  }

  public async obterVeiculosAsistencia(placa: string): Promise<VeiculoModelAssistencia[]> {
    const veiculoDTO = await consultaVeiculoApi.obterInformacoesVeiculo(placa);
    return this.parseVeiculoAssistencia(veiculoDTO);
  }

  private parseVeiculoAssistencia(veiculoDTO: DadosVeiculoInfoCarDTO) {
    return [
      {
        placa: veiculoDTO.placa,
        marca: veiculoDTO.marca,
        modelo: veiculoDTO.modelo,
        anoFabricacao: veiculoDTO.anoFabricacao,
        anoModelo: veiculoDTO.anoModelo,
        cor: veiculoDTO.cor,
        chassi: veiculoDTO.chassi,
        tipoVeiculo: TIPOS_VEICULO_ASSISTENCIA.find((tipo) => {
          return (tipo.valor == veiculoDTO.tipoVeiculo);
        }),
      },
    ];
  }
}

export const consultaVeiculoService = new ConsultaVeiculoService();
